import AbstractPageBaseController from '../../../../modules/core/abstracts/controllers/page-controller';

export default class BillingPositionCategoriesAbstractEditorController extends AbstractPageBaseController {
    constructor($scope, $injector) {
        super($scope, $injector);

        this.navHelper = this.injector.get('NavHelper');
        this.stateParams = this.injector.get('$stateParams');
        this.state = this.injector.get('$state');
        this.alert = this.injector.get('Alert');
        this.translate = this.injector.get('$translate');
        this.api = this.injector.get('$http');

        this.model = {
            title: ''
        };
        this.loading = true;
        this.categories = [];
        this.submitting = false;
    }

    $onInit() {

    }

    save(form) {
        if (!form.$valid) {
            return;
        }
        this.submitting = true;

        this.doSave();
    }

    doSave() {
        console.log('do save not implemented');
    }

    cancel() {
        if (this.stateParams.store) {
            this.stateParams.store.dispatch('getData');
        }
        this.state.go('app.billing.position_categories.index');
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/billing/position_categories/controllers/abstract-editor-controller.js